import { createContext, useRef, useState } from "react";

export const BlockerContext = createContext<any>("");

export enum steps {
  RELOAD,
  MEMBER,
  FINISHED,
  SIGNUP,
  EDITPROFIL,
  ORDERS,
  SIGNIN,
  GIFT,
  SUBSCRIPTION_PAYMENT,
  LOADING,
  WHO,
  WHAT,
  SUPPORTUS,
  CONTACTUS,
  AWLAD_SCHOOL
}

const BlockerContextProvider = (props: any) => {
	const [block, setBlock] = useState<boolean>();
	const [itemId, setItemId] = useState<string>();
  const [unblockStep, setUnblockStep] = useState<steps>(props.initialSteps || steps.MEMBER);
  const nextStep = useRef<steps | undefined>(props.nextSteps);

	return (
		<BlockerContext.Provider value={{ itemId, setItemId, block, setBlock, unblockStep, setUnblockStep, nextStep }} >
			{props.children}
		</BlockerContext.Provider>
	);
};

export default BlockerContextProvider;
